import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-disbursementmodal',
  templateUrl: './disbursementmodal.component.html',
  styleUrls: ['./disbursementmodal.component.css']
})
export class DisbursementmodalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
